var normalizeComponent = require("!../../node_modules/_vue-loader@13.7.3@vue-loader/lib/component-normalizer")
/* script */
export * from "!!babel-loader!../../node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!../../node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!../../node_modules/_vue-loader@13.7.3@vue-loader/lib/selector?type=script&index=0!./head.vue"
import __vue_script__ from "!!babel-loader!../../node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!../../node_modules/_vue-loader@13.7.3@vue-loader/lib/selector?type=script&index=0!./head.vue"
/* template */
import __vue_template__ from "!!../../node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler/index?{\"id\":\"data-v-70fa7a21\",\"hasScoped\":false,\"transformToRequire\":{\"video\":[\"src\",\"poster\"],\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"},\"buble\":{\"transforms\":{}}}!../../node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!../../node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!../../node_modules/_vue-loader@13.7.3@vue-loader/lib/selector?type=template&index=0!./head.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/head.vue
// module id = null
// module chunks = 